/**
 * Use with Vue.config.keyCodes (https://vuejs.org/v2/api/#keyCodes).
 *
 * May be used individually like:
 *  import { end, home, down, up } from 'keyCodes';
 * or all together like:
 *  import * as keyCodes from 'keyCodes';
 */
export const del = 46;
export const down = 40;
export const end = 35;
export const enter = 13;
export const home = 36;
export const left = 37;
export const pgDn = 34;
export const pgUp = 33;
export const right = 39;
export const space = 32;
export const up = 38;
